import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { smartphoneDimensions } from '../../devices';
import { frameworkHandlers, frameworkReducer, frameworkReducerInitialState } from '../reducers/FrameworkReducer';
import { ParentContext } from './ParentContext';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';
import { usePermissionGroups } from './useHelpers/usePermissionGroups';

export const FrameworkContext = createContext();

/**
 * 
 * @param {object} props 
 * @returns a simple FrameworkContext providing framework_state and framework_handlers
 */
const FrameworkProvider = (props) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { paps_state, page_state, appSettings_state, appUser_state } = states ?? {}
  const { appUser } = appUser_state ?? {}
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { viewItems } = aps_page ?? {}
  const appUserAccess = useAppUserAccess()

  const { view, pathViews, appViewMode } = paps_state ?? {}
  const { desktopMode } = appSettings_state ?? {}

  const init_state = { ...props, view, pathViews, appViewMode, appUser, smartphone: smartphoneDimensions.smartphone }
  const [framework_state, functions_dispatch] = useReducer(frameworkReducer, frameworkReducerInitialState(init_state));

  const framework_handlers = useMemo(
    () => frameworkHandlers(functions_dispatch),
    [functions_dispatch]
  );

  const permissionGroups = usePermissionGroups()

  useEffect(() => {
    // framework_handlers.handleInit_framework(parentContext)
    framework_handlers.handleClear_navigationItems()
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [viewItems, pathViews.events, pathViews.clients, appUserAccess]);

  useEffect(() => {
    framework_handlers.handleSet_permissionGroups(permissionGroups)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [permissionGroups]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [framework_state.currentRefs]);

  return <FrameworkContext.Provider value={{ framework_state: { ...framework_state, desktopMode }, framework_handlers }}>
    {props.children}
  </FrameworkContext.Provider>
};

export default FrameworkProvider